export enum DeleteRequisiteActionTypes {
  request = 'requisite/DELETE_REQUISITE/REQUEST',
  success = 'requisite/DELETE_REQUISITE/SUCCESS',
  failure = 'requisite/DELETE_REQUISITE/FAILURE',
  cancel = 'requisite/DELETE_REQUISITE/CANCEL',
}

export enum GetRequisitesActionTypes {
  request = 'requisite/GET_REQUISITES/REQUEST',
  success = 'requisite/GET_REQUISITES/SUCCESS',
  failure = 'requisite/GET_REQUISITES/FAILURE',
  cancel = 'requisite/GET_REQUISITES/CANCEL',
}

export enum CreateRequisitesActionTypes {
  request = 'requisite/CREATE_REQUISITES/REQUEST',
  success = 'requisite/CREATE_REQUISITES/SUCCESS',
  failure = 'requisite/CREATE_REQUISITES/FAILURE',
  cancel = 'requisite/CREATE_REQUISITES/CANCEL',
}

export enum UpdateRequisitesActionTypes {
  request = 'requisite/UPDATE_REQUISITES/REQUEST',
  success = 'requisite/UPDATE_REQUISITES/SUCCESS',
  failure = 'requisite/UPDATE_REQUISITES/FAILURE',
  cancel = 'requisite/UPDATE_REQUISITES/CANCEL',
}

export enum DownloadFileByUrlActionTypes {
  request = 'requisite/DOWNLOAD_FILE/REQUEST',
  success = 'requisite/DOWNLOAD_FILE/SUCCESS',
  failure = 'requisite/DOWNLOAD_FILE/FAILURE',
  cancel = 'requisite/DOWNLOAD_FILE/CANCEL',
}
